import { useApolloClient } from '@apollo/client';
import useIsLoggedIn from '@apps/www/src/www/hooks/useIsLoggedIn';
import TrackUpgradeClickMutation from '@apps/www/src/www/queries/TrackUpgradeClickMutation';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';

const useTrackUpgradeClick = () => {
	const isLoggedIn = useIsLoggedIn();
	const client = useApolloClient();

	const trackUpgradeClick = useEventCallback((source: ValueOf<typeof UpgradeButtonSource>) => {
		if (isLoggedIn) {
			client.mutate({
				mutation: TrackUpgradeClickMutation,
				variables: {
					input: {
						source,
					},
				},
			});
		}
	});

	return trackUpgradeClick;
};

export default useTrackUpgradeClick;